import { render, staticRenderFns } from "./TabEpoxy.vue?vue&type=template&id=787f4f1d&"
import script from "./TabEpoxy.vue?vue&type=script&lang=js&"
export * from "./TabEpoxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports